import { IModelBase } from 'common-components'
import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface ILog extends IModelBase {
  EntityId: string
  EntityType: string
  Details: string
  Exception: string
  StackTrace: string
}

@Injectable()
export class LogODataService extends ODataService<ILog> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Logs'
  }
}
